import { useCallback } from 'react';
import { useFocusEffect } from 'hooks';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { selectShouldFetchCreditReportForDebtTracking } from '../selectors';
import useGetCreditReport from './useGetCreditReport';
/**
 * Refreshes the credit report whenever the screen gains focus, so the
 * trackable debts behind the "Track debts in net worth" card are up to date.
 */
const useFetchCreditReportForDebtTracking = () => {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const fetchCreditReport = useGetCreditReport();
    useFocusEffect(useCallback(() => {
        if (selectShouldFetchCreditReportForDebtTracking(store.getState())) {
            dispatch(fetchCreditReport());
        }
    }, [dispatch, fetchCreditReport, store]));
};
export default useFetchCreditReportForDebtTracking;
